/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  CreateStonePriceRuleRequest,
  DeleteStonePriceRulePathParameters,
  DeleteStoneSettingPathParameters,
  GetStoneSettingPathParameters,
  ListStonePriceRules200,
  PutStoneSettingPathParameters,
  PutStoneSettingRequest,
  StonePriceRule,
  StoneSetting,
  UpdateStonePriceRulePathParameters,
  UpdateStonePriceRuleRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary The stone markup bands of the organization
 */
export const listStonePriceRules = (

 options?: SecondParameter<typeof customInstance<ListStonePriceRules200>>,) => {
      return customInstance<ListStonePriceRules200>(
      {url: `/admin/v1/org/stone-price-rules`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create a stone markup band
 */
export const createStonePriceRule = (
    createStonePriceRuleRequest: BodyType<CreateStonePriceRuleRequest>,
 options?: SecondParameter<typeof customInstance<StonePriceRule>>,) => {
      return customInstance<StonePriceRule>(
      {url: `/admin/v1/org/stone-price-rules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStonePriceRuleRequest
    },
      options);
    }
  /**
 * @summary Update a stone markup band. stoneType is immutable.
 */
export const updateStonePriceRule = (
    { id }: UpdateStonePriceRulePathParameters,
    updateStonePriceRuleRequest: BodyType<UpdateStonePriceRuleRequest>,
 options?: SecondParameter<typeof customInstance<StonePriceRule>>,) => {
      return customInstance<StonePriceRule>(
      {url: `/admin/v1/org/stone-price-rules/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateStonePriceRuleRequest
    },
      options);
    }
  /**
 * @summary Delete a stone markup band
 */
export const deleteStonePriceRule = (
    { id }: DeleteStonePriceRulePathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/org/stone-price-rules/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary The stones a product accepts as a configurator setting
 */
export const getStoneSetting = (
    { productId }: GetStoneSettingPathParameters,
 options?: SecondParameter<typeof customInstance<StoneSetting>>,) => {
      return customInstance<StoneSetting>(
      {url: `/admin/v1/org/products/${productId}/stone-setting`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Mark a product a setting, or change the stones it accepts
 */
export const putStoneSetting = (
    { productId }: PutStoneSettingPathParameters,
    putStoneSettingRequest: BodyType<PutStoneSettingRequest>,
 options?: SecondParameter<typeof customInstance<StoneSetting>>,) => {
      return customInstance<StoneSetting>(
      {url: `/admin/v1/org/products/${productId}/stone-setting`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putStoneSettingRequest
    },
      options);
    }
  /**
 * @summary Stop selling a product as a configurator setting
 */
export const deleteStoneSetting = (
    { productId }: DeleteStoneSettingPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/org/products/${productId}/stone-setting`, method: 'DELETE'
    },
      options);
    }
  export type ListStonePriceRulesResult = NonNullable<Awaited<ReturnType<typeof listStonePriceRules>>>
export type CreateStonePriceRuleResult = NonNullable<Awaited<ReturnType<typeof createStonePriceRule>>>
export type UpdateStonePriceRuleResult = NonNullable<Awaited<ReturnType<typeof updateStonePriceRule>>>
export type DeleteStonePriceRuleResult = NonNullable<Awaited<ReturnType<typeof deleteStonePriceRule>>>
export type GetStoneSettingResult = NonNullable<Awaited<ReturnType<typeof getStoneSetting>>>
export type PutStoneSettingResult = NonNullable<Awaited<ReturnType<typeof putStoneSetting>>>
export type DeleteStoneSettingResult = NonNullable<Awaited<ReturnType<typeof deleteStoneSetting>>>
